import { Product, ID } from "../../types/server";
import types from "./types";
import utils from "./utils";

export type ProductsState = {
  [k in ID]: Product;
};
export const init_state: ProductsState = {};

export default function categoiresReducer(state = init_state, action) {
  switch (action.type) {
    case types.SET_PRODUCTS:
      return utils.products_format(action.payload.products);
    default:
      return state;
  }
}
